import { PropsWithChildren } from 'react';

import { cn } from 'app/utils/styles.utils';

type PageContainerProps = PropsWithChildren<{
  className?: string;
}>;

export const PageContainer = ({children, className}: PageContainerProps) => {
  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-[calc(1236px+_60px)] flex-1 flex-col gap-5 px-[30px] py-5 mobile:gap-2.5 mobile:px-2.5 mobile:py-2.5',
        className,
      )}>
      {children}
    </div>
  );
};
